import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import Login from './Login'
import ModalProvider from './ModalContext';
import Dashboard from './Dashboard'
function AdminApp() {


    return (
        <main>
            <div className="container-fluid" data-bs-theme="light">
                <ModalProvider>
                    <Routes>
                        <Route path="/" element={<Navigate to="dashboard" replace={true} />} />  
                        <Route path="/dashboard*" element={<Dashboard />} />
                        <Route path="/login" element={<Login />} />
                    </Routes>
                </ModalProvider>
            </div >
        </main>
    );
}

export default AdminApp;
